<template>
  <ancestryline-modal title="protocol.tab-checklist.add-person-checklist"  id="add-certificate-modal" :close="true" @close="close" :loading="false">

    <card>
      <coff-input-select v-model="category" label="protocol.tab-checklist.form.category-of-person" class="p-col-12 p-md-3 p-lg-3" :options="categories" option-value="id" :error="validation.category"/>
      <coff-input-auto-complete v-model="client" label="protocol.tab-checklist.form.name" class="p-col-12 p-md-6 p-lg-4" :itens="clients" field="name" :func-suggestions="searchClient" :error="validation.client"/>
      <a class="cursor-pointer p-col-1 p-md-1 p-lg-1" @click.prevent="modalClientForm" style="margin-top: 30px;"><i class="pi pi-users" :title="$t('menu.client.form')"/></a>
      <coff-input-select v-if="category && category !== immigrant" v-model="parent" :show-eraser="true" option-label="person.name" label="protocol.tab-checklist.form.parent" class="p-col-12 p-md-4 p-lg-4" :options="fathersMothersListFilter" option-value="id" :error="validation.parent"/>
    </card>

    <template #footer>
      <Button class="p-mr-2" @click="close()">{{$t('btn.cancel')}}</Button>
      <Button :label="$t('btn.save')" @click="save" class="p-ml-auto p-button-success"/>
    </template>
  </ancestryline-modal>
</template>

<script>
import ValidationUtils from "@/utils/ValidationUtils";
import DialogService from "@/business/ModalBusiness";
import {ASCENDANT, CATEGORY_OF_CERTIFICATES, IMMIGRANT, UNDER_AGE} from "@/constants/CategoryOfCertificates";
import ClientBusiness from "@/business/ClientBusiness";
import ModalClientForm from "@/viewer/client/ModalClientForm";

export default {
  name: "ModalAddCertificate",

  props: ["clientsProtocol", "checklists", "checklistPersonToEdit"],

  data(){
    return {
      client: null,
      parent: null,
      clients: [],
      category: null,
      underAge: UNDER_AGE,
      immigrant: IMMIGRANT,
      ascendant: ASCENDANT,
      categories: CATEGORY_OF_CERTIFICATES,
      fathersMothersList: null,
      validation: {
          category: false,
          parent: false,
          client: false,
      },
    }
  },

  mounted() {
    this.clients = this.clientsProtocol.map(cp => cp.client);
    this.fathersMothersList = this.getChecklistWithoutTree(this.checklists, []);
    if (this.checklistPersonToEdit) {
        this.$set(this, "category", this.checklistPersonToEdit.category);
        this.client = this.checklistPersonToEdit.person;
        if(this.checklistPersonToEdit.parent) {
            this.$set(this, "parent", this.fathersMothersList.filter(p => p.id === this.checklistPersonToEdit.parent.id)[0].id);
        }
    }
  },

  computed: {
      fathersMothersListFilter() {
        return this.fathersMothersList.filter(cpp => (!this.client || cpp.person.id !== this.client.id)).sort((a, b) => a.checklistOrder + b.checklistOrder);
      }
  },

  methods: {
    close(){
      DialogService.closeModal();
    },

    save(){
        let validationForm = {client: this.client && this.client.id ? this.client : null, category: this.category, parent: this.parent};
        if (this.category && this.category !== this.immigrant) {
            this.validation.parent = false;
        } else {
            delete this.validation.parent;
        }
        this.validation = ValidationUtils.basicValidation(this.validation, validationForm);
        if(!this.validation.erros){
            DialogService.closeModal({client: this.client, category: this.category, parent: this.parent});
        }
    },

    getChecklistWithoutTree(checklists, newChecklist){
        checklists.forEach(checklist => {
            if ((checklist.children != null && checklist.children.length > 0) && ((this.checklistPersonToEdit.person && this.checklistPersonToEdit.person.id !== checklist.person.id) || !this.checklistPersonToEdit.person)) {
                newChecklist = this.getChecklistWithoutTree(checklist.children, newChecklist);
            }
            if (newChecklist.filter(cpp=>cpp.id===checklist.id).length === 0) {
                newChecklist.push(checklist);
            }
        });
        return newChecklist.sort(function(a,b) {
            return a.category > b.category ? -1 : a.category < b.category ? 1 : 0;
        });
    },

    async searchClient(name){
      return await ClientBusiness.search(name);
    },

    async modalClientForm(){
        const client = await DialogService.openModal(ModalClientForm, {}, 1000);
        if(client){
            this.$set(this, 'client', client);
        }
    }

  },

}
</script>

<style scoped>

</style>